<div class="header">
    <img src="assets/images/Isolation_Mode.svg" alt="App Icon" class="icon" style="align-items: start;">

    <div class="buttons">
        <button (click)="onPricing()">Pricing</button>
        <button (click)="onContactUs()">Contact Us</button>
        <button class="sign-in-btn" (click)="onSignin()">Sign In</button>
        <button (click)="onSignup()">Try For Free</button>
    </div>
    <div class="menu-toggle" (click)="toggleMobileMenu()">
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>

<div class="content">
    <div class="hero-row">
        <div class="text-section">
            <h2>
                Visualize Hip-Hop Data
                and<br>
                Unlock Patterns of
                Culture</h2>
            <p>
                We are a big data platform to search and map the birth <br>
                and spread of words and styles found in 1,000,000 songs.
            </p>
            <div class="auth-buttons">
                <button class="sign-in1" (click)="onSignin()">Sign In</button>
                <button class="sign-up" (click)="onSignup()">Sign Up</button>
            </div>
        </div>
    </div>

    <div class="image-section-fpo">
        <video #demoVideo autoplay loop muted playsinline preload="auto" class="balanced-animation"
            poster="assets/images/rapalmanac-landing-poster.jpg">
            <source src="assets/images/rapalmanac-landing-video.mp4" type="video/mp4">
        </video>
    </div>


    <div class="features-section">
        <h2>Key Features</h2>
        <p class=" description">
            Discover the power of data-driven <br> hip-hop insights. Search, analyze, and <br>visualize song lyric data
            with
            ease.
        </p>

        <div class="features-container">
            <div class="feature" *ngFor="let feature of features">
                <div class="feature-icon">
                    <img [src]="feature.icon" [alt]="feature.title">
                </div>
                <h3>{{ feature.title }}</h3>
                <p>{{ feature.description }}</p>
            </div>
        </div>
    </div>


    <div class="features-section">
        <h2>Who’s It For?</h2>
        <p class="description">
            Empowering researchers, educators,<br>and developers with comprehensive<br>hip-hop data analysis tools.
        </p>

        <div class="features-container">
            <div class="feature" *ngFor="let feature of itFor">
                <div class="feature-icon">
                    <img [src]="feature.icon" [alt]="feature.title">
                </div>
                <h3>{{ feature.title }}</h3>
                <p>{{ feature.description }}</p>
            </div>
        </div>
    </div>

    <div class="features-section">
        <h2>Pricing</h2>
        <p class="description" id="pricingId">
            Flexible plans for every type of user—<br>from casual explorers to data-driven<br>developers.
        </p>
        <rap-stripe-pricing> </rap-stripe-pricing>
    </div>
    <div class="features-section">
        <h3 style="align-items: center; text-align: center; color: #141516; font-weight: 400; font-size: 22px; padding-top: 30px; 
                font-family: 'UberMove', sans-serif !important;">
            Trusted
            by top
            institutions to turn
            cultural data into
            strategy, storytelling,
            and innovation.</h3>

    </div>

    <div class="logo-row">
        <img src="assets/images/nyt.png" alt="New York Times" />
        <img src="assets/images/nyu.png" alt="NYU" />
        <img src="assets/images/nyc-parks.png" alt="NYC Parks" />
        <img src="assets/images/harvard.png" alt="Harvard University" />
        <img src="assets/images/umbc.svg" alt="UMBC" />
    </div>
    <div style="height: 50px;"></div>

    <div class="footer-header">
        <div class="footer-container">


            <div class="footer-column" *ngFor="let section of footerSections;">
                <h3 *ngIf="section.title">{{ section.title }}</h3>
                <ul>
                    <li *ngFor="let item of section.items">
                        <ng-container *ngIf="item.link; else plainText">
                            <ng-container *ngIf="item.link.startsWith('http'); else internalLink">
                                <a [href]="item.link" target="_blank" rel="noopener noreferrer" class="footer-link">
                                    {{ item.label }}
                                </a>
                            </ng-container>
                            <ng-template #internalLink>
                                <ng-container *ngIf="item.scrollToTop; else routerLinkTemplate">
                                    <a href="javascript:void(0);" (click)="handleFooterLinkClick(item)"
                                        class="footer-link">
                                        {{ item.label }}
                                    </a>
                                </ng-container>
                                <ng-template #routerLinkTemplate>
                                    <a [routerLink]="item.link" target="_blank" class="footer-link">
                                        {{ item.label }}
                                    </a>
                                </ng-template>
                            </ng-template>
                        </ng-container>
                        <ng-template #plainText>
                            <span style=" font-size: 12px; font-weight: normal;color: #7A7D81;">{{ item.label
                                }}</span>
                        </ng-template>
                    </li>

                </ul>

            </div>

        </div>
        <div style="align-items: start; justify-self: start; color: #7A7D81;  font-size: 12px;
                                                                            font-weight: 400;
                                                                            text-align: start;">© {{ currentYear }} Rap Almanac
        </div>

    </div>
</div>